import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from 'apollo-link-http';
import envConfig from '@nile/home/src/Config/env';
import gql from 'graphql-tag';
import { Card } from '@shopify/polaris';
import { Button, DisplayText } from '@superops/ui-design-system';
import { GET_INVOICE, AccountClient, GET_CLIENT } from '@nile/graphql';
import { GET_MSP_COMPANY } from '@nile/banyan/src/Graphql/Mutations/msp';
import { useQuery, useMutation } from '@apollo/client';
import shortid from 'shortid';
import styled from 'styled-components';
import {
  B1,
  HeaderTag,
  DisabledTag,
  Tag,
  getDownloadURL,
  ALL_MODULES
} from '@nile/components';
import InvoiceItemsTable from '@nile/client_management/src/Containers/TableContainers/InvoiceItemsTable';

const ROW_COUNT = 200;

function InvoiceSheet(props) {
  const { clientId, invoiceId } = props.data;
  console.log(clientId, invoiceId);
  const {
    data: invoiceData,
    loading: invoiceLoading,
    error: invoiceError
  } = useQuery(GET_INVOICE, {
    client: AccountClient,
    variables: {
      clientId: clientId,
      invoiceId: invoiceId
    }
  });
  const {
    loading: clientLoading,
    error: clientError,
    data,
    refetch
  } = useQuery(GET_CLIENT, {
    fetchPolicy: 'network-only',
    client: AccountClient,
    variables: { clientId: clientId }
  });
  const {
    loading: companyLoading,
    error: companyError,
    data: mspcompany
  } = useQuery(GET_MSP_COMPANY, {
    client: AccountClient,
    fetchPolicy: 'network-only'
  });
  if (invoiceLoading || clientLoading || companyLoading)
    return <div>loading...</div>;
  const invoice = invoiceData.getInvoice;
  const client = data.getClient;
  const company = mspcompany.getMSPCompany;
  const typeMap = {
    CONTRACT: 'Contract',
    TICKET: 'Ticket'
  };
  const headers = [];
  headers.push({
    label: 'Product/Service',
    accessor: 'itemName',
    type: 'TEXT',
    id: 'itemName'
  });
  if (invoice.invoiceType === 'TICKET') {
    headers.push({
      label: 'Ticket ID',
      accessor: 'worklogItem.worklog.ticket.displayId',
      type: 'TEXT',
      id: 'ticketID'
    });
  }
  headers.push({
    label: 'Quantity',
    accessor: 'quantity',
    type: 'TEXT',
    id: 'quantity'
  });
  headers.push({
    label: 'Unit price',
    accessor: 'unitPrice',
    type: 'TEXT',
    id: 'unitPrice'
  });
  headers.push({
    label: 'Cost',
    accessor: 'amount',
    type: 'TEXT',
    id: 'amount'
  });
  const columns =
    invoice.items?.length > 0
      ? headers.map((col) => {
          return {
            Header: col.label,
            accessor: col.accessor,
            type: col.type,
            id: col.id
          };
        })
      : [];
  return (
    <div className="vh100 vw50 scroll p20">
      <div className="flex center mb-20">
        <DisplayText element="h1" size="extraLarge" weight="Bold">
          {`${typeMap[invoice.invoiceType]} Invoices`}
        </DisplayText>

        <Tag className="ml8">{invoice.status}</Tag>
        {invoice.status === 'Draft' ? (
          <div className="mlauto">
            <Button primary>Send to Client</Button>
          </div>
        ) : (
          ''
        )}
      </div>
      <div>
        <Card customClassName="m-0">
          <div className="flex">
            <DisplayText element="h1" size="extraLarge" weight="Bold">
              {`${typeMap[invoice.invoiceType]} Invoice #${invoice.displayId}`}
            </DisplayText>

            <div className="flex fcol aend mlauto">
              <div className="lh-30">
                Invoice date : {`${invoice.invoiceDate}`}
              </div>
              <div className="lh-30">Due date : {`${invoice.dueDate}`}</div>
            </div>
          </div>
          <div className="mt-30">
            <HeaderTag isBgStrip title="Invoice from" />
            <div className="flex">
              <div>
                <div className="mr-16 flex center jcenter">
                  <img
                    className="h-30 w-30"
                    src={`${envConfig.imageRoot}svg/superopsLight.svg`}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <div className="lh-30">
                  <B1>{company.name}</B1>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-30">
            <HeaderTag isBgStrip title="Billing information" />
            <div className="flex">
              <div>
                <Logo className="logo" client={client} />
              </div>
              <div>
                <div className="lh-30">
                  <B1>{client.name}</B1>
                </div>
                <div className="lh-30">
                  {client.address || <DisabledTag>NA</DisabledTag>}
                </div>
                <div className="lh-30">
                  {client.state || <DisabledTag>NA</DisabledTag>}
                </div>
                <div className="lh-30">
                  {client.country || <DisabledTag>NA</DisabledTag>}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-30">
            <HeaderTag isBgStrip title="Invoice items" />
            <InvoiceItemsTable
              columns={columns}
              data={invoice.items}
              rowCount={ROW_COUNT}
              pagination={Math.ceil(invoice.items.length / ROW_COUNT) > 1}
              pages={Math.ceil(invoice.items.length / ROW_COUNT) || 0}
              activePage={0}
            />
            <div className="flex mt10 mlauto">
              <div
                style={{
                  backgroundColor: 'var(--sops-rmm-tree-select-bg)'
                }}
                className="flex mlauto p8 br-5"
              >
                <div>Total</div>
                <div className="ml8">{invoice.totalAmount}</div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

function Logo(props) {
  const { client } = props;
  const { logoFileName, accountId, downloadURL } = client;
  const module = ALL_MODULES.clientAvatar;
  const details = {
    fileName: logoFileName,
    clientId: accountId
  };
  const fallbackUrl = getDownloadURL({ module, details });
  const downloadUrl = downloadURL || fallbackUrl;
  return (
    <div className="flex center mr-16">
      <img
        className="h-30"
        src={downloadUrl}
        url={downloadUrl}
        alt={downloadUrl}
      />
    </div>
  );
}

export default withRouter(InvoiceSheet);
